import React from "react";

import { SelectChangeEvent } from "@mui/material";

import Dropdown, {
  DropdownProps,
} from "@app/common/components/Dropdown/Dropdown";
import DropdownMenuItem from "@app/common/components/Dropdown/DropdownMenuItem";
import { getSelectedFromOptions } from "@app/common/components/Dropdown/utils";
import { EnterpriseWorkspaceSettings } from "@app/common/workspaces/types";

const OPTIONS = [
  {
    label: "Set default, allow users to update this preference",
    value: "true",
  },
  {
    label: "Do not allow users to update this preference",
    value: "false",
  },
];

interface WorkspaceCanEditDropdownProps extends Omit<DropdownProps, "name"> {
  onUpdate: (value: boolean, name: keyof EnterpriseWorkspaceSettings) => void;
  selectedValue: boolean;
  name: keyof EnterpriseWorkspaceSettings;
}

const WorkspaceCanEditDropdown = ({
  onUpdate,
  selectedValue,
  sx,
  ...dropdownProps
}: WorkspaceCanEditDropdownProps) => {
  const handleChange = (event: SelectChangeEvent) => {
    // the dropdown doesn't like having boolean values as the option values,
    // so coerce the stringified value into a boolean
    const value = event.target.value === "true";
    onUpdate(value, dropdownProps.name);
  };

  return (
    <Dropdown
      {...dropdownProps}
      selectedItem={getSelectedFromOptions(OPTIONS, `${selectedValue}`)}
      onChange={handleChange}
      sx={{ ...sx, width: "600px", maxWidth: "100%" }}
    >
      {OPTIONS.map((item) => {
        const isSelectedItem = item.value === `${selectedValue}`;
        return (
          <DropdownMenuItem
            key={item.value}
            {...item}
            selected={isSelectedItem}
          />
        );
      })}
    </Dropdown>
  );
};

export default WorkspaceCanEditDropdown;
